module.exports = __webpack_public_path__ + "static/img/11.eee3194.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/gameNewPic/11.jpg
// module id = dhVs
// module chunks = 1